// image-processing-loader
var previousRequest = require("!!../../../../../node_modules/fox-file-loader/index.js!../../../../../node_modules/file-loader/index.js?name=[path][name].[ext]!./video-example.jpg");
var dir = previousRequest.replace("video-example.jpg", "")
module.exports = require("!../../../../../node_modules/fox-image-optimize-plugin/router.js")({
	dir: dir,
	base: "video-example.jpg",
	name: "video-example",
	ext: ".jpg",
	query: ""
}, previousRequest);


//////////////////
// WEBPACK FOOTER
// ./images/video-example.jpg
// module id = 1026
// module chunks = 4